export const packageList = [
  {
    name: 'hr',
    activeRule: ['hr'],
    // preload: true
  },
  {
    name: 'hr_train',
    activeRule: ['hr-train'],
  },
  {
    name: 'legal',
    activeRule: ['lms'],
  },
  {
    name: 'flow',
    activeRule: ['oa'],
    preload: true
  },
  {
    name: 'kts',
    activeRule: ['kts'],
  },
  {
    name: 'tic',
    activeRule: ['tic'],
  },
]

export const remoteModuleConfig = {
  dev: ['hr', 'legal', 'flow', 'kts', 'tic', 'hr_train'],
  stg: ['hr', 'legal', 'flow', 'kts', 'tic', 'hr_train'],
  uat: ['hr', 'legal', 'flow', 'kts', 'tic', 'hr_train'],
  prd: ['hr', 'legal', 'flow', 'kts', 'tic', 'hr_train'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/hr/index.js